import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/sale.png'


const _hoisted_1 = { class: "banner banner--active discount-banner" }
const _hoisted_2 = { class: "banner__inner discount-banner__inner" }
const _hoisted_3 = { class: "banner__left" }
const _hoisted_4 = { class: "banner__title discount-banner__title" }
const _hoisted_5 = { class: "banner__description discount-banner__description" }
const _hoisted_6 = { class: "discount-banner__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('discount_banner.title')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('discount_banner.no_commission')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('discount_banner.no_bank_card')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('discount_banner.safely')), 1)
          ])
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "banner__right" }, [
        _createElementVNode("div", { class: "banner__img" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "banner-img"
          })
        ])
      ], -1))
    ])
  ]))
}